import {
  Paper,
  Box,
  Checkbox,
  useTheme,
  Typography,
  IconButton,
} from "@mui/material";
import { CameraAlt, CheckBox, CheckBoxOutlineBlank } from "@mui/icons-material";
import React from "react";
import { Material, ProjectData, Tool } from "../../interfaces/TaskDetails";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export type IMaterialCardProps = {
  projectData: ProjectData | null;
  id: string | undefined;
  tool: Tool[] | null;
  isLastTaskToComplete: (material: Material) => void;
};

const MaterialCard: React.FC<IMaterialCardProps> = ({
  projectData,
  id,
  tool,
  isLastTaskToComplete,
}) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const getMaterialData = (item: Material) => {
    if (projectData?.is_removal_task) {
      return t("taskDetails.no_materials_msg")
    } else if (projectData?.is_repair_non_material_task) {
      return t("taskDetails.no_materials_repair_msg")
    } else if (!projectData?.is_removal_task) {
      return `Plaats ${item?.material_count} van ${item?.material_name}`
    }
  }

  return (
    <Paper
      elevation={3}
      sx={{
        p: 2,
        pb: 0,
        width: "90%",
        maxHeight: "195px",
        overflow: "auto",
        mt: "25px",
      }}
    >
      {projectData?.materials && projectData?.materials?.length > 0 ? (
        projectData?.materials.map((item: Material, index: number) => (
          <Box
            key={index}
            sx={{
              display: "flex",
              alignItems: "center",
              mb: 2,
            }}
          >
            <Checkbox
              checked={!!item.material_status}
              disabled
              sx={{
                "&.Mui-disabled": {
                  color: theme.palette.primary.main,
                },
                alignSelf: "flex-start",
                padding: "3px",
                paddingLeft: "0px",
              }}
              icon={<CheckBoxOutlineBlank fontSize="medium" />}
              checkedIcon={<CheckBox fontSize="medium" />}
            />
            <Box sx={{ flex: 1, ml: "2px" }}>
              <Typography
                fontFamily={"Nunito Sans SemiBold"}
                sx={{
                  fontSize: "16px",
                  color: theme.palette.primary.main,
                }}
              >
                {
                  getMaterialData(item)
                }
              </Typography>
              <Typography
                fontFamily="Nunito Sans Regular500"
                fontSize="14px"
                sx={{
                  color: theme.palette.primary.main,
                }}
              >
                {item?.material_address}
              </Typography>
            </Box>

            <Box sx={{ ml: "auto", mr: 2, alignSelf: "flex-start" }}>
              <IconButton
                sx={{
                  color: theme.palette.primary.main,
                  width: "30px",
                  height: "26px",
                }}
                size="large"
                onClick={() =>
                  navigate(`/updatetaskdetail/${id}`, {
                    state: {
                      projectData: projectData,
                      materialData: item,
                      tool: tool,
                      taskId: id,
                      is_removal_task: projectData?.is_removal_task,
                      isLastTaskToComplete: isLastTaskToComplete(item),
                    },
                  })
                }
              >
                <CameraAlt fontSize="medium" />
              </IconButton>
            </Box>
          </Box>
        ))
      ) : (
        <Typography
          sx={{ mb: 2, fontFamily: "Nunito Sans Regular700", fontSize: "14px" }}
        >
          {t("common.no_data_msg")}
        </Typography>
      )}
    </Paper>
  );
};

export { MaterialCard };
